import React from "react"
import { Popover } from "react-bootstrap"

const ratmPopover = (title: string, text: string[]) => (
    <Popover id="ratm-popover">
        <Popover.Title>
            <div className="ratmPopoverTitle">
                {title}
            </div>
        </Popover.Title>
        <Popover.Content>
            {text.map((text, i) =>
                <div key={i} className="ratmPopoverContentItem">
                    <p>{text}</p>
                </div>
            )}
        </Popover.Content>
    </Popover>
)

export default ratmPopover